import clsx from 'clsx';
import styles from './Text.module.scss';
import { TPolymorphicProps } from '../../../types/utils';

type TTextProps<T extends React.ElementType> = TPolymorphicProps<T> & { className?: string }

export const Text = <T extends React.ElementType = 'p'>({
  as,
  children,
  className,
}: TTextProps<T>) => {
  const Component = as || 'p';
  const classNames = clsx(
    styles.text,
    className
  );

  return <Component className={classNames}>{children}</Component>;
};
